export default function DOM_CreateNodes() {
  return (
    <div>
      <h1>DOM_CreateNodes</h1>
      <p>This is the DOM_CreateNodes component.</p>
    </div>
  );
}